import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  NaiveDateTime: string;
  Time: any;
  Upload: string;
};

export type Appointment = {
  __typename?: 'Appointment';
  appointmentAttachments?: Maybe<Array<Maybe<AppointmentAttachment>>>;
  comment?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['NaiveDateTime']>;
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  notes?: Maybe<Array<Maybe<AppointmentNotes>>>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['ID']>;
  procedure?: Maybe<Procedure>;
  profile: Profile;
  questionnaireAnswerSets?: Maybe<Array<Maybe<QuestionnaireAnswerSetObj>>>;
  referral?: Maybe<Referral>;
  referralId?: Maybe<Scalars['ID']>;
  rescheduledFrom?: Maybe<Appointment>;
  rescheduledTo?: Maybe<Appointment>;
  rescheduleLink?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['NaiveDateTime']>;
  status: Scalars['String'];
  tags?: Maybe<Array<Maybe<AppointmentTags>>>;
};

export type AppointmentAttachment = {
  __typename?: 'AppointmentAttachment';
  attachmentUrl?: Maybe<Scalars['String']>;
  displayFilename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type AppointmentFilters = {
  __typename?: 'AppointmentFilters';
  appointmentStatuses: Array<Maybe<ListAppointmentsFilterObj>>;
  profiles: Array<Maybe<ListAppointmentsFilterObj>>;
  specialties: Array<Maybe<ListAppointmentsFilterObj>>;
};

export type AppointmentNotes = {
  __typename?: 'AppointmentNotes';
  author: Scalars['String'];
  body: Scalars['String'];
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export enum AppointmentOrdering {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AppointmentSortColumn {
  ApptTime = 'APPT_TIME',
  InsertedAt = 'INSERTED_AT'
}

export type AppointmentTags = {
  __typename?: 'AppointmentTags';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AppointmentTagsInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AppointmentUrl = {
  __typename?: 'AppointmentUrl';
  url: Scalars['String'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action: Scalars['String'];
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  organizationId?: Maybe<Scalars['ID']>;
  recordContext?: Maybe<Array<Maybe<RecordContextItem>>>;
  recordId: Scalars['ID'];
  user?: Maybe<User>;
};

export type AuditLogsWithPagination = {
  __typename?: 'AuditLogsWithPagination';
  entries: Array<Maybe<AuditLog>>;
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Availability = {
  __typename?: 'Availability';
  end: Scalars['String'];
  id: Scalars['ID'];
  scheduleId: Scalars['ID'];
  start: Scalars['String'];
  weekDay: Scalars['String'];
};

export type AvailabilityLimit = {
  __typename?: 'AvailabilityLimit';
  count: Scalars['Int'];
  end?: Maybe<Scalars['NaiveDateTime']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  start: Scalars['NaiveDateTime'];
  userId: Scalars['ID'];
};

export type AvailabilityLimitSummary = {
  __typename?: 'AvailabilityLimitSummary';
  currentAvailability?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  futureLimits?: Maybe<Array<Maybe<AvailabilityLimit>>>;
  pastLimits?: Maybe<Array<Maybe<AvailabilityLimit>>>;
};

export type AvailableReferralFilters = {
  __typename?: 'AvailableReferralFilters';
  apptStatuses?: Maybe<Array<Maybe<ReferralFilterObj>>>;
  createdByUsers?: Maybe<Array<Maybe<ReferralFilterObj>>>;
  procedures?: Maybe<Array<Maybe<ReferralFilterObj>>>;
  profiles?: Maybe<Array<Maybe<ReferralFilterObj>>>;
  providers?: Maybe<Array<Maybe<ReferralFilterObj>>>;
  referralStatuses?: Maybe<Array<Maybe<ReferralFilterObj>>>;
};

export type BillingPortalSession = {
  __typename?: 'BillingPortalSession';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type BlackoutDate = {
  __typename?: 'BlackoutDate';
  end: Scalars['Date'];
  endTime?: Maybe<Scalars['Time']>;
  id: Scalars['ID'];
  reason?: Maybe<BlackoutDateReason>;
  scheduleId: Scalars['ID'];
  slotId?: Maybe<Scalars['ID']>;
  start: Scalars['Date'];
  startTime?: Maybe<Scalars['Time']>;
};

export enum BlackoutDateReason {
  Appointment = 'APPOINTMENT',
  OutOfOffice = 'OUT_OF_OFFICE'
}

export type BootstrapOrganizationInput = {
  email?: InputMaybe<Scalars['String']>;
  isCovid?: InputMaybe<Scalars['Boolean']>;
  isFree?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type CapabilityStatement = {
  __typename?: 'CapabilityStatement';
  name?: Maybe<Scalars['String']>;
};

export type ChimeAttendee = {
  __typename?: 'ChimeAttendee';
  attendeeId: Scalars['String'];
  externalUserId: Scalars['String'];
  joinToken: Scalars['String'];
};

export type ChimeMeeting = {
  __typename?: 'ChimeMeeting';
  audioFallbackUrl: Scalars['String'];
  audioHostUrl: Scalars['String'];
  externalMeetingId: Scalars['String'];
  mediaRegion: Scalars['String'];
  meetingId: Scalars['String'];
  screenDataUrl: Scalars['String'];
  screenSharingUrl: Scalars['String'];
  screenViewingUrl: Scalars['String'];
  signalingUrl: Scalars['String'];
  turnControlUrl: Scalars['String'];
};

export type CloneProfileInput = {
  profileId: Scalars['ID'];
};

export type CodeableConcept = {
  __typename?: 'CodeableConcept';
  coding?: Maybe<Array<Maybe<Coding>>>;
  text?: Maybe<Scalars['String']>;
};

export type Coding = {
  __typename?: 'Coding';
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  userSelected?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type ConsumerPatient = {
  __typename?: 'ConsumerPatient';
  id: Scalars['ID'];
};

export type ConsumerSchedulingSettings = {
  __typename?: 'ConsumerSchedulingSettings';
  allowAttachments: Scalars['Boolean'];
  formFieldSettings?: Maybe<Array<Maybe<FormFieldSettings>>>;
  googleTagManagerId?: Maybe<Scalars['String']>;
  htmlFooter?: Maybe<Scalars['String']>;
  htmlHeader?: Maybe<Scalars['String']>;
  htmlHeadTags?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  noAvailabilityAction?: Maybe<Scalars['String']>;
  noAvailabilityText?: Maybe<Scalars['String']>;
  searchInsurance: Scalars['Boolean'];
  searchProviders?: Maybe<Scalars['Boolean']>;
  showLanguages?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
  showPatientPrefill?: Maybe<Scalars['Boolean']>;
  visitTypeFormLabel?: Maybe<Scalars['String']>;
};

export enum ConsumerSchedulingSort {
  Distance = 'DISTANCE',
  NextAvailability = 'NEXT_AVAILABILITY'
}

export type Coverage = {
  __typename?: 'Coverage';
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  network?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
};

export type CreateAvailabilityInput = {
  end: Scalars['String'];
  scheduleId: Scalars['ID'];
  start: Scalars['String'];
  weekDay: Scalars['String'];
};

export type CreateBlackoutDateInput = {
  end: Scalars['Date'];
  endTime?: InputMaybe<Scalars['Time']>;
  reason?: InputMaybe<BlackoutDateReason>;
  scheduleId: Scalars['ID'];
  slotId?: InputMaybe<Scalars['ID']>;
  start: Scalars['Date'];
  startTime?: InputMaybe<Scalars['Time']>;
};

export type CreateConsumerSchedulingEngagementInput = {
  appointmentAttachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  comment?: InputMaybe<Scalars['String']>;
  end: Scalars['NaiveDateTime'];
  order?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  procedureId: Scalars['ID'];
  profileId: Scalars['ID'];
  questionnaireAnswerSets?: InputMaybe<Array<InputMaybe<QuestionnaireAnswerSet>>>;
  slotIds: Array<Scalars['ID']>;
  start: Scalars['NaiveDateTime'];
  tags?: InputMaybe<InputEngagementTags>;
};

export type CreateConsumerSchedulingEngagementInstantInput = {
  comment?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  procedureId: Scalars['ID'];
  profileId: Scalars['ID'];
  tags?: InputMaybe<InputEngagementTags>;
};

export type CreateGroupInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  isReferralNetwork?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreateGroupOrganizationInput = {
  groupId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type CreateGroupProfileInput = {
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type CreateLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  linkTypeId: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
  profileId?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
};

export type CreateLinkTypeInput = {
  linkType: Scalars['String'];
  linkTypeScope: Scalars['String'];
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type CreateLocationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  hasAppointmentRequests: Scalars['Boolean'];
  key?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  timeZone: TimeZone;
};

export type CreateMessageInput = {
  body?: InputMaybe<Scalars['String']>;
  referralId: Scalars['ID'];
};

export type CreateOrganizationInput = {
  isFree?: Scalars['Boolean'];
  name: Scalars['String'];
  regionId?: InputMaybe<Scalars['ID']>;
};

export type CreatePatientCoverageInput = {
  insuranceCarrier?: InputMaybe<Scalars['String']>;
  insuranceGroupNumber?: InputMaybe<Scalars['String']>;
  insurancePlan?: InputMaybe<Scalars['String']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']>;
};

export type CreatePatientInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dob: Scalars['Date'];
  email?: InputMaybe<Scalars['String']>;
  familyName: Scalars['String'];
  givenName1: Scalars['String'];
  givenName2?: InputMaybe<Scalars['String']>;
  givenName3?: InputMaybe<Scalars['String']>;
  insuranceCarrier?: InputMaybe<Scalars['String']>;
  insuranceGroupNumber?: InputMaybe<Scalars['String']>;
  insurancePlan?: InputMaybe<Scalars['String']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneType?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredLanguageCode?: InputMaybe<Scalars['String']>;
  sex: Sex;
  state?: InputMaybe<Scalars['String']>;
};

export type CreatePatientReferralInput = {
  diagnoses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  diagnosesDescription?: InputMaybe<Scalars['String']>;
  patientEmail?: InputMaybe<Scalars['String']>;
  profileId: Scalars['ID'];
  questionnaireAnswerSets?: InputMaybe<Array<InputMaybe<QuestionnaireAnswerSetSendTo>>>;
  referralId: Scalars['ID'];
  serviceTypeCode?: InputMaybe<Scalars['String']>;
  serviceTypeSystem?: InputMaybe<Scalars['String']>;
};

export type CreatePaymentsSubscriptionInput = {
  defaultTaxRates: Array<InputMaybe<Scalars['ID']>>;
  organizationName: Scalars['String'];
  paymentMethodId: Scalars['String'];
  priceId: Scalars['ID'];
  quantity: Scalars['Int'];
  regionId?: InputMaybe<Scalars['ID']>;
};

export type CreateProfileProcedureInput = {
  cptCode?: InputMaybe<Scalars['String']>;
  duration: Scalars['Int'];
  procedureId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type CreateProfileReferralInput = {
  diagnoses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  diagnosesDescription?: InputMaybe<Scalars['String']>;
  patientEmail?: InputMaybe<Scalars['String']>;
  profileId: Scalars['ID'];
  questionnaireAnswerSets?: InputMaybe<Array<InputMaybe<QuestionnaireAnswerSetSendTo>>>;
  referralId: Scalars['ID'];
  serviceTypeCode?: InputMaybe<Scalars['String']>;
  serviceTypeSystem?: InputMaybe<Scalars['String']>;
};

export type CreateProviderInput = {
  isActive: Scalars['Boolean'];
  key?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  npi: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreateUserInput = {
  email: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  password: Scalars['String'];
};

export type DeleteAvailabilityInput = {
  id: Scalars['ID'];
  scheduleId: Scalars['ID'];
};

export type DeleteAvailabilityLimitInput = {
  limitId: Scalars['ID'];
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type DeleteBlackoutDateInput = {
  id: Scalars['ID'];
  scheduleId: Scalars['ID'];
};

export type DeleteGroupOrganizationInput = {
  groupId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type DeleteGroupProfileInput = {
  groupId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type Directory = {
  __typename?: 'Directory';
  organizations?: Maybe<Array<Maybe<DirectoryOrganization>>>;
  specialties?: Maybe<Array<Maybe<Specialty>>>;
};

export type DirectoryOrganization = {
  __typename?: 'DirectoryOrganization';
  id: Scalars['ID'];
  name: Scalars['String'];
  profileImgUrl?: Maybe<Scalars['String']>;
  specialties?: Maybe<Array<Maybe<Specialty>>>;
};

export type Eligibility = {
  __typename?: 'Eligibility';
  eligible?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  payload?: Maybe<Scalars['String']>;
};

export type Engagement = {
  __typename?: 'Engagement';
  comment?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['NaiveDateTime']>;
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  procedure?: Maybe<Procedure>;
  profile: PublicProfile;
  start?: Maybe<Scalars['NaiveDateTime']>;
  status: Scalars['String'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FormFieldSettings = {
  __typename?: 'FormFieldSettings';
  field: Scalars['String'];
  required: Scalars['Boolean'];
};

export type FreePlanConfiguration = {
  __typename?: 'FreePlanConfiguration';
  appointmentsPerWeek?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  locations?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  profiles?: Maybe<Scalars['Int']>;
  providers?: Maybe<Scalars['Int']>;
  users?: Maybe<Scalars['Int']>;
};

export type Geocode = {
  __typename?: 'Geocode';
  id: Scalars['ID'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  location: Scalars['String'];
  locationSearch: Scalars['Boolean'];
  zip: Scalars['String'];
  zipCount?: Maybe<Scalars['Int']>;
};

export type GetLocationInput = {
  id: Scalars['ID'];
};

export type GetProviderInput = {
  id: Scalars['ID'];
};

export type GetWaitListAvailabilitiesInput = {
  procedureId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isAllLocations: Scalars['Boolean'];
  isReferralNetwork: Scalars['Boolean'];
  locations?: Maybe<Array<Location>>;
  name: Scalars['String'];
  organization: Organization;
  organizations?: Maybe<Array<Organization>>;
  profiles?: Maybe<Array<Profile>>;
};

export type InputEngagementTags = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmCmpid?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type LanguageInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type Link = {
  __typename?: 'Link';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  linkTypeId: Scalars['ID'];
  locationId?: Maybe<Scalars['ID']>;
  profileId?: Maybe<Scalars['ID']>;
  url: Scalars['String'];
};

export type LinkFilter = {
  id?: InputMaybe<Scalars['ID']>;
  linkTypeId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  profileId?: InputMaybe<Scalars['ID']>;
};

export type LinkType = {
  __typename?: 'LinkType';
  id: Scalars['ID'];
  linkType: Scalars['String'];
  linkTypeScope: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type LinkTypeFilter = {
  id?: InputMaybe<Scalars['ID']>;
  linkType?: InputMaybe<Scalars['String']>;
  linkTypeScope?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type ListAppointmentsFilterObj = {
  __typename?: 'ListAppointmentsFilterObj';
  text?: Maybe<Scalars['String']>;
  value: Scalars['ID'];
};

export type ListAvailabilitiesInput = {
  scheduleId: Scalars['ID'];
};

export type ListBlackoutDatesInput = {
  reason?: InputMaybe<BlackoutDateReason>;
  scheduleId: Scalars['ID'];
};

export type Location = {
  __typename?: 'Location';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  distanceFromPatient?: Maybe<Scalars['Float']>;
  distanceFromProvider?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  hasAppointmentRequests: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  timeZone: TimeZone;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String'];
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  user: User;
};

export type Organization = {
  __typename?: 'Organization';
  accessCenterProfileId?: Maybe<Scalars['ID']>;
  cancelReasons?: Maybe<Array<Maybe<Reason>>>;
  consumerSchedulingSettings?: Maybe<ConsumerSchedulingSettings>;
  customEmailSubject?: Maybe<Scalars['String']>;
  customEmailText?: Maybe<Scalars['String']>;
  defaultDateFilterRange?: Maybe<Scalars['String']>;
  defaultReferralSearchRadius?: Maybe<Scalars['Int']>;
  defaultReferralSort?: Maybe<Scalars['String']>;
  enablePatientCancellation?: Maybe<Scalars['Boolean']>;
  enablePatientRescheduling?: Maybe<Scalars['Boolean']>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  freePlanConfiguration?: Maybe<FreePlanConfiguration>;
  groups?: Maybe<Array<Maybe<Group>>>;
  hasSso: Scalars['Boolean'];
  hasSsoStrict: Scalars['Boolean'];
  hideEmailFieldInReferral?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isCovid: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  locations?: Maybe<Array<Maybe<Location>>>;
  maxInactiveUserDays?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  patientEmailFromAddress?: Maybe<Scalars['String']>;
  preAuthorizedProcedures?: Maybe<Array<Maybe<Scalars['ID']>>>;
  preAuthorizedSpecialties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  profileImgUrl?: Maybe<Scalars['String']>;
  profiles?: Maybe<Array<Maybe<Profile>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  receivedReferralsCount?: Maybe<Scalars['Int']>;
  referralCancelReasons?: Maybe<Array<Maybe<Reason>>>;
  referralRejectionReasons?: Maybe<Array<Maybe<Reason>>>;
  referralSettings?: Maybe<ReferralSettings>;
  region: Region;
  searchProfilesWithoutScheduling?: Maybe<Scalars['Boolean']>;
  sendPatientNotifications?: Maybe<Scalars['Boolean']>;
  sentReferralsCount?: Maybe<Scalars['Int']>;
  showInsuranceFilters?: Maybe<Scalars['Boolean']>;
  showInsuranceFiltersDuringScheduling?: Maybe<Scalars['Boolean']>;
  showSendToPatient?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  useClickToSearchForPatients?: Maybe<Scalars['Boolean']>;
};


export type OrganizationGroupsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  isReferralNetwork?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
};


export type OrganizationProvidersArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
};

export type OrganizationFormFieldSettingsInput = {
  field: Scalars['String'];
  required: Scalars['Boolean'];
};

export type PaginatedAppointments = {
  __typename?: 'PaginatedAppointments';
  entries: Array<Maybe<Appointment>>;
  filters: AppointmentFilters;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedLocations = {
  __typename?: 'PaginatedLocations';
  entries: Array<Maybe<Location>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedProfiles = {
  __typename?: 'PaginatedProfiles';
  entries?: Maybe<Array<Maybe<Profile>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedProviders = {
  __typename?: 'PaginatedProviders';
  entries?: Maybe<Array<Maybe<Provider>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedPublicProfiles = {
  __typename?: 'PaginatedPublicProfiles';
  entries?: Maybe<Array<Maybe<PublicProfile>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedSchedules = {
  __typename?: 'PaginatedSchedules';
  entries?: Maybe<Array<Maybe<Schedule>>>;
  filters?: Maybe<Scalars['String']>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  entries?: Maybe<Array<Maybe<User>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Patient = {
  __typename?: 'Patient';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  coverage?: Maybe<Coverage>;
  dob: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  familyName: Scalars['String'];
  gender: Scalars['String'];
  givenName1: Scalars['String'];
  givenName2?: Maybe<Scalars['String']>;
  givenName3?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  preferredLanguageCode?: Maybe<Scalars['String']>;
  sex: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type PatientDemographic = {
  __typename?: 'PatientDemographic';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  dob: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  familyName: Scalars['String'];
  gender: Scalars['String'];
  givenName1: Scalars['String'];
  givenName2?: Maybe<Scalars['String']>;
  givenName3?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  preferredLanguageCode?: Maybe<Scalars['String']>;
  sex: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type PatientReferral = {
  __typename?: 'PatientReferral';
  id: Scalars['ID'];
  patientEmail?: Maybe<Scalars['String']>;
  profile?: Maybe<PublicProfile>;
  referralId: Scalars['ID'];
};

export type PaymentsSubscription = {
  __typename?: 'PaymentsSubscription';
  id: Scalars['ID'];
  items: Array<Maybe<SubscriptionItem>>;
  organizationId: Scalars['ID'];
  status: Scalars['String'];
};

export type Payor = {
  __typename?: 'Payor';
  id: Scalars['ID'];
  name: Scalars['String'];
  payorPlans?: Maybe<Array<Maybe<PayorPlan>>>;
};

export type PayorPlan = {
  __typename?: 'PayorPlan';
  id: Scalars['ID'];
  name: Scalars['String'];
  payor?: Maybe<Payor>;
  payorId: Scalars['ID'];
  profilePlans?: Maybe<Array<Maybe<ProfilePlan>>>;
};

export type Price = {
  __typename?: 'Price';
  active: Scalars['Boolean'];
  billingScheme: Scalars['String'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
  paymentsProduct: Product;
  recurring: PriceRecurring;
  type: Scalars['String'];
  unitAmount: Scalars['Int'];
};

export type PriceRecurring = {
  __typename?: 'PriceRecurring';
  aggregateUsage?: Maybe<Scalars['String']>;
  interval?: Maybe<Scalars['String']>;
  intervalCount?: Maybe<Scalars['Int']>;
  usageType?: Maybe<Scalars['String']>;
};

export type Procedure = {
  __typename?: 'Procedure';
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isUnspecified?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not a FHIR Coding field.  Use display. */
  name?: Maybe<Scalars['String']>;
  specialty?: Maybe<Specialty>;
  system?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  prices?: Maybe<Array<Maybe<Price>>>;
  type: Scalars['String'];
};

export type Profile = {
  __typename?: 'Profile';
  boardCertifications?: Maybe<Scalars['String']>;
  boardCertificationsSafe?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  educationTraining?: Maybe<Scalars['String']>;
  educationTrainingSafe?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  generalPatientInstructions?: Maybe<Scalars['String']>;
  generalPatientInstructionsSafe?: Maybe<Scalars['String']>;
  groupKey?: Maybe<Scalars['String']>;
  hasAppointmentRequests: Scalars['Boolean'];
  hasConsumerScheduling: Scalars['Boolean'];
  hasConsumerSchedulingSlots: Scalars['Boolean'];
  hasReferralScheduling: Scalars['Boolean'];
  hasReferralSchedulingSlots: Scalars['Boolean'];
  id: Scalars['ID'];
  isAccessCenter: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isGlobal: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  isSendToPatient: Scalars['Boolean'];
  isSendToProvider: Scalars['Boolean'];
  isWaitList: Scalars['Boolean'];
  languages?: Maybe<Array<Maybe<Language>>>;
  lastName?: Maybe<Scalars['String']>;
  location: Location;
  maintenanceMode: Scalars['Boolean'];
  nextAvailability?: Maybe<Scalars['String']>;
  npiNumber?: Maybe<Scalars['String']>;
  onlyAllowsAgeMax?: Maybe<Scalars['Int']>;
  onlyAllowsAgeMin?: Maybe<Scalars['Int']>;
  organization: Organization;
  phone?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  prescreeningQuestionnaire?: Maybe<Array<Maybe<Questionnaire>>>;
  professionalStatement?: Maybe<Scalars['String']>;
  professionalStatementSafe?: Maybe<Scalars['String']>;
  profileImgUrl?: Maybe<Scalars['String']>;
  profileProcedures?: Maybe<Array<Maybe<ProfileProcedure>>>;
  referralSearchNotice?: Maybe<Scalars['String']>;
  referralSearchNoticeSafe?: Maybe<Scalars['String']>;
  scheduleId?: Maybe<Scalars['ID']>;
  slotStartBufferInM?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


export type ProfilePrescreeningQuestionnaireArgs = {
  procedureId: Scalars['ID'];
  sendingOrganizationId?: InputMaybe<Scalars['ID']>;
};

export type ProfileLimit = {
  __typename?: 'ProfileLimit';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  profileId: Scalars['ID'];
  type: Scalars['String'];
};

export type ProfilePayor = {
  __typename?: 'ProfilePayor';
  payor?: Maybe<Payor>;
  payorId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type ProfilePlan = {
  __typename?: 'ProfilePlan';
  payorPlan?: Maybe<PayorPlan>;
  payorPlanId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type ProfileProcedure = {
  __typename?: 'ProfileProcedure';
  durationInMinutes?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  procedure: Procedure;
  profile: Profile;
};

export type ProfileReferral = {
  __typename?: 'ProfileReferral';
  id: Scalars['ID'];
  patientEmail?: Maybe<Scalars['String']>;
  profile?: Maybe<PublicProfile>;
  referralId: Scalars['ID'];
};

export enum ProfileType {
  Device = 'DEVICE',
  Group = 'GROUP',
  Location = 'LOCATION',
  Practitioner = 'PRACTITIONER'
}

export type Provider = {
  __typename?: 'Provider';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  name: Scalars['String'];
  npi: Scalars['String'];
  organization: Organization;
};

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  consumerSchedulingSettings?: Maybe<ConsumerSchedulingSettings>;
  hasAlluviumRebrandFeature?: Maybe<Scalars['Boolean']>;
  hasConsumerSchedulingShowWeekendsFeature?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locationsWithProfiles?: Maybe<Array<Maybe<Location>>>;
  name: Scalars['String'];
  profileImgUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type PublicProfile = {
  __typename?: 'PublicProfile';
  boardCertifications?: Maybe<Scalars['String']>;
  boardCertificationsSafe?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  educationTraining?: Maybe<Scalars['String']>;
  educationTrainingSafe?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  generalPatientInstructions?: Maybe<Scalars['String']>;
  generalPatientInstructionsSafe?: Maybe<Scalars['String']>;
  hasConsumerScheduling: Scalars['Boolean'];
  id: Scalars['ID'];
  isAccessCenter: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  isSendToPatient: Scalars['Boolean'];
  isSendToProvider: Scalars['Boolean'];
  isWaitList: Scalars['Boolean'];
  languages?: Maybe<Array<Maybe<Language>>>;
  lastName?: Maybe<Scalars['String']>;
  location: Location;
  nextAvailability?: Maybe<Scalars['String']>;
  npiNumber?: Maybe<Scalars['String']>;
  organization: PublicOrganization;
  phone?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  prescreeningQuestionnaire?: Maybe<Array<Maybe<Questionnaire>>>;
  professionalStatement?: Maybe<Scalars['String']>;
  professionalStatementSafe?: Maybe<Scalars['String']>;
  profileImgUrl?: Maybe<Scalars['String']>;
  profileProcedures?: Maybe<Array<Maybe<ProfileProcedure>>>;
  specialties?: Maybe<Array<Maybe<Specialty>>>;
  specialty?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


export type PublicProfilePrescreeningQuestionnaireArgs = {
  procedureId: Scalars['ID'];
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<QuestionnaireItems>>>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subjectType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QuestionnaireAnswer = {
  key?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type QuestionnaireAnswerObj = {
  __typename?: 'QuestionnaireAnswerObj';
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type QuestionnaireAnswerSendTo = {
  key?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type QuestionnaireAnswerSet = {
  questionnaireAnswers?: InputMaybe<Array<InputMaybe<QuestionnaireAnswer>>>;
  questionnaireId: Scalars['ID'];
  questionnaireName: Scalars['String'];
};

export type QuestionnaireAnswerSetObj = {
  __typename?: 'QuestionnaireAnswerSetObj';
  id: Scalars['ID'];
  questionnaireAnswers?: Maybe<Array<Maybe<QuestionnaireAnswerObj>>>;
  questionnaireName: Scalars['String'];
};

export type QuestionnaireAnswerSetSendTo = {
  questionnaireAnswers?: InputMaybe<Array<InputMaybe<QuestionnaireAnswerSendTo>>>;
  questionnaireId: Scalars['ID'];
  questionnaireName: Scalars['String'];
};

export type QuestionnaireItems = {
  __typename?: 'QuestionnaireItems';
  answerMaxLength?: Maybe<Scalars['Int']>;
  answerValidators?: Maybe<Array<Maybe<QuestionnaireItemsAnswerValidators>>>;
  helpText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialValue?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  required?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uploadAcceptTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuestionnaireItemsAnswerValidators = {
  __typename?: 'QuestionnaireItemsAnswerValidators';
  questionnaireId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type Reason = {
  __typename?: 'Reason';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type RecordContextItem = {
  __typename?: 'RecordContextItem';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Referral = {
  __typename?: 'Referral';
  appointment?: Maybe<Appointment>;
  bookedByProvider?: Maybe<Scalars['Boolean']>;
  coverage?: Maybe<Coverage>;
  createdByUser: User;
  description?: Maybe<Scalars['String']>;
  diagnoses: Array<Maybe<Diagnosis>>;
  documents?: Maybe<Array<Maybe<ReferralDocument>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']>;
  insuranceGroupNumber?: Maybe<Scalars['String']>;
  insurancePolicyNumber?: Maybe<Scalars['String']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  matchedPayorId?: Maybe<Scalars['String']>;
  nextStatuses?: Maybe<Array<Maybe<Scalars['String']>>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String'];
  patientIsPreAuthorized?: Maybe<Scalars['Boolean']>;
  patientReferral?: Maybe<PatientReferral>;
  payorPlan?: Maybe<PayorPlan>;
  procedure: Procedure;
  procedureId: Scalars['ID'];
  profileReferral?: Maybe<ProfileReferral>;
  provider: Provider;
  questionnaireAnswerSets?: Maybe<Array<Maybe<QuestionnaireAnswerSetObj>>>;
  receiverResponse?: Maybe<Scalars['String']>;
  referralOrder?: Maybe<Array<Maybe<ReferralOrder>>>;
  result?: Maybe<Scalars['String']>;
  showScreening?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  tags?: Maybe<Array<Maybe<ReferralTags>>>;
  tasks?: Maybe<Array<Maybe<WorkflowQueueTask>>>;
};


export type ReferralReceiverResponseArgs = {
  organizationId: Scalars['ID'];
};


export type ReferralTagsArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type ReferralDocument = {
  __typename?: 'ReferralDocument';
  displayFilename?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
  referralId: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type ReferralFilterObj = {
  __typename?: 'ReferralFilterObj';
  text?: Maybe<Scalars['String']>;
  value: Scalars['ID'];
};

export type ReferralInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  procedureId?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ReferralOrder = {
  __typename?: 'ReferralOrder';
  displayFilename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum ReferralOrdering {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum ReferralResponseAction {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED'
}

export type ReferralSettings = {
  __typename?: 'ReferralSettings';
  distinctReferralsTableByAppointments?: Maybe<Scalars['Boolean']>;
  enableCancelAndRescheduleButton?: Maybe<Scalars['Boolean']>;
  enableRejectReferralWithAppointment?: Maybe<Scalars['Boolean']>;
  enableSearchLinkWhenCanceled?: Maybe<Scalars['Boolean']>;
  hideReferralOrder?: Maybe<Scalars['Boolean']>;
  hideSchedulingButtons?: Maybe<Scalars['Boolean']>;
  isDiagnosisRequired?: Maybe<Scalars['Boolean']>;
  isNoteRequired?: Maybe<Scalars['Boolean']>;
  useDeclineReferralLabel?: Maybe<Scalars['Boolean']>;
};

export enum ReferralSortColumn {
  ApptTime = 'APPT_TIME',
  InsertedAt = 'INSERTED_AT'
}

export type ReferralStatusInput = {
  cancelNote?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  rejectNote?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ReferralsWithPagination = {
  __typename?: 'ReferralsWithPagination';
  entries: Array<Maybe<Referral>>;
  filters: AvailableReferralFilters;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ReferralTags = {
  __typename?: 'ReferralTags';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum ReferralViewType {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Reservation = {
  __typename?: 'Reservation';
  token: Scalars['String'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acceptDeclineReferral?: Maybe<Referral>;
  acceptTask: WorkflowQueueTask;
  addAppointmentNotes?: Maybe<Appointment>;
  addTask: WorkflowQueueTask;
  appendReferralResult?: Maybe<Referral>;
  bootstrapOrganization?: Maybe<Organization>;
  cancelReferral?: Maybe<Referral>;
  changePassword?: Maybe<User>;
  cloneProfile?: Maybe<Profile>;
  completeReferral?: Maybe<Referral>;
  createAppointment?: Maybe<Appointment>;
  createAvailability?: Maybe<Availability>;
  createAvailabilityLimit?: Maybe<AvailabilityLimit>;
  createBlackoutDate?: Maybe<BlackoutDate>;
  createConsumerSchedulingEngagement?: Maybe<Engagement>;
  createConsumerSchedulingPatient?: Maybe<ConsumerPatient>;
  createGroup?: Maybe<Group>;
  createGroupOrganization?: Maybe<Group>;
  createGroupProfile?: Maybe<Group>;
  createLink?: Maybe<Link>;
  createLinkType?: Maybe<LinkType>;
  createLocation?: Maybe<Location>;
  createMessage?: Maybe<Message>;
  createOrganization?: Maybe<Organization>;
  createPasswordReset?: Maybe<User>;
  createPatient?: Maybe<Patient>;
  createPatientCoverage?: Maybe<Coverage>;
  createPatientReferral?: Maybe<PatientReferral>;
  createPaymentsSubscription?: Maybe<PaymentsSubscription>;
  createProfilePlan?: Maybe<ProfilePlan>;
  createProfileProcedure?: Maybe<Procedure>;
  createProfileReferral?: Maybe<ProfileReferral>;
  createProvider?: Maybe<Provider>;
  createQuizResult?: Maybe<Scalars['String']>;
  createReferral?: Maybe<Referral>;
  createScheduleForOrganization?: Maybe<Profile>;
  createUser?: Maybe<User>;
  createUserInOrganization?: Maybe<User>;
  deleteAvailability?: Maybe<Scalars['ID']>;
  deleteAvailabilityLimit?: Maybe<Scalars['ID']>;
  deleteBlackoutDate?: Maybe<Scalars['ID']>;
  deleteGroupOrganization?: Maybe<Group>;
  deleteGroupProfile?: Maybe<Group>;
  deleteLink?: Maybe<Link>;
  deleteLinkType?: Maybe<LinkType>;
  deleteProfilePayor?: Maybe<ProfilePayor>;
  deleteProfilePlan?: Maybe<ProfilePlan>;
  deleteProfileProcedure?: Maybe<ProfileProcedure>;
  deleteReferralDocument?: Maybe<ReferralDocument>;
  deleteReferralOrder?: Maybe<ReferralOrder>;
  disableProfileLimit?: Maybe<ProfileLimit>;
  editUser?: Maybe<User>;
  enableProfileLimit?: Maybe<ProfileLimit>;
  finishTask: WorkflowQueueTask;
  freeSlots?: Maybe<Reservation>;
  reserveSlots?: Maybe<Reservation>;
  superuserUpdateOrganization?: Maybe<Organization>;
  updateAppointment?: Maybe<Appointment>;
  updateGroup?: Maybe<Group>;
  updateGroupLocations?: Maybe<Group>;
  updateLink?: Maybe<Link>;
  updateLinkType?: Maybe<LinkType>;
  updateLocation?: Maybe<Location>;
  updateOrganization?: Maybe<Organization>;
  updateOrganizationConsumerSchedulingSettings?: Maybe<ConsumerSchedulingSettings>;
  updatePatientDemographic?: Maybe<PatientDemographic>;
  updatePatientReferral?: Maybe<PatientReferral>;
  updateProfileReferral?: Maybe<ProfileReferral>;
  updateProvider?: Maybe<Provider>;
  updateReferral?: Maybe<Referral>;
  updateReferralStatus?: Maybe<Referral>;
  updateSchedule?: Maybe<Profile>;
  updateUserOrganizationEmailNotifications?: Maybe<UserOrganization>;
  updateUserOrganizationSmsNotifications?: Maybe<UserOrganization>;
  uploadAppointmentAttachment?: Maybe<Appointment>;
  uploadReferralDocument?: Maybe<Scalars['String']>;
  uploadReferralOrder?: Maybe<Scalars['String']>;
  uploadScheduleImage?: Maybe<Scalars['String']>;
  upsertSchedule?: Maybe<Profile>;
  upsertSlotDuration?: Maybe<SlotDuration>;
  watchQueue: WorkflowQueue;
};


export type RootMutationTypeAcceptDeclineReferralArgs = {
  action: ReferralResponseAction;
  reason?: InputMaybe<Scalars['String']>;
  referralId: Scalars['ID'];
};


export type RootMutationTypeAcceptTaskArgs = {
  taskId: Scalars['ID'];
};


export type RootMutationTypeAddAppointmentNotesArgs = {
  body: Scalars['String'];
  id: Scalars['ID'];
};


export type RootMutationTypeAddTaskArgs = {
  notes?: InputMaybe<Scalars['String']>;
  questionnaireAnswerSets?: InputMaybe<Array<InputMaybe<QuestionnaireAnswerSet>>>;
  referralId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  workflowQueueId: Scalars['ID'];
};


export type RootMutationTypeAppendReferralResultArgs = {
  referralId: Scalars['ID'];
  result: Scalars['String'];
};


export type RootMutationTypeBootstrapOrganizationArgs = {
  bootstrapOrganizationInput?: InputMaybe<BootstrapOrganizationInput>;
};


export type RootMutationTypeCancelReferralArgs = {
  cancelNote?: InputMaybe<Scalars['String']>;
  cancelReason: Scalars['String'];
  referralId: Scalars['ID'];
};


export type RootMutationTypeChangePasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  newPasswordConfirmation: Scalars['String'];
  userId: Scalars['ID'];
};


export type RootMutationTypeCloneProfileArgs = {
  cloneProfileInput: CloneProfileInput;
};


export type RootMutationTypeCompleteReferralArgs = {
  referralId: Scalars['ID'];
};


export type RootMutationTypeCreateAppointmentArgs = {
  bookedByProvider?: InputMaybe<Scalars['Boolean']>;
  diagnoses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  diagnosesDescription?: InputMaybe<Scalars['String']>;
  end: Scalars['NaiveDateTime'];
  notificationEmail?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  profileId: Scalars['ID'];
  questionnaireAnswerSets?: InputMaybe<Array<InputMaybe<QuestionnaireAnswerSet>>>;
  referralId: Scalars['ID'];
  serviceTypeCode?: InputMaybe<Scalars['String']>;
  serviceTypeSystem?: InputMaybe<Scalars['String']>;
  slotIds: Array<Scalars['ID']>;
  start: Scalars['NaiveDateTime'];
};


export type RootMutationTypeCreateAvailabilityArgs = {
  createAvailabilityInput: CreateAvailabilityInput;
};


export type RootMutationTypeCreateAvailabilityLimitArgs = {
  count: Scalars['Int'];
  end?: InputMaybe<Scalars['NaiveDateTime']>;
  note?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
  start: Scalars['NaiveDateTime'];
};


export type RootMutationTypeCreateBlackoutDateArgs = {
  createBlackoutDateInput: CreateBlackoutDateInput;
};


export type RootMutationTypeCreateConsumerSchedulingEngagementArgs = {
  createConsumerSchedulingEngagementInput?: InputMaybe<CreateConsumerSchedulingEngagementInput>;
  createConsumerSchedulingEngagementInstantInput?: InputMaybe<CreateConsumerSchedulingEngagementInstantInput>;
  organizationId: Scalars['ID'];
};


export type RootMutationTypeCreateConsumerSchedulingPatientArgs = {
  createPatientInput: CreatePatientInput;
  organizationId: Scalars['ID'];
};


export type RootMutationTypeCreateGroupArgs = {
  createGroupInput: CreateGroupInput;
};


export type RootMutationTypeCreateGroupOrganizationArgs = {
  createGroupOrganizationInput: CreateGroupOrganizationInput;
};


export type RootMutationTypeCreateGroupProfileArgs = {
  createGroupProfileInput: CreateGroupProfileInput;
};


export type RootMutationTypeCreateLinkArgs = {
  createLinkInput: CreateLinkInput;
};


export type RootMutationTypeCreateLinkTypeArgs = {
  createLinkTypeInput: CreateLinkTypeInput;
};


export type RootMutationTypeCreateLocationArgs = {
  createLocationInput: CreateLocationInput;
  organizationId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateMessageArgs = {
  createMessageInput: CreateMessageInput;
};


export type RootMutationTypeCreateOrganizationArgs = {
  createOrganizationInput: CreateOrganizationInput;
};


export type RootMutationTypeCreatePasswordResetArgs = {
  userId: Scalars['ID'];
};


export type RootMutationTypeCreatePatientArgs = {
  createPatientInput: CreatePatientInput;
  organizationId: Scalars['ID'];
};


export type RootMutationTypeCreatePatientCoverageArgs = {
  createPatientCoverageInput: CreatePatientCoverageInput;
  organizationId: Scalars['ID'];
  patientId: Scalars['ID'];
};


export type RootMutationTypeCreatePatientReferralArgs = {
  createPatientReferralInput: CreatePatientReferralInput;
};


export type RootMutationTypeCreatePaymentsSubscriptionArgs = {
  createPaymentsSubscriptionInput?: InputMaybe<CreatePaymentsSubscriptionInput>;
};


export type RootMutationTypeCreateProfilePlanArgs = {
  planId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type RootMutationTypeCreateProfileProcedureArgs = {
  createProfileProcedureInput: CreateProfileProcedureInput;
};


export type RootMutationTypeCreateProfileReferralArgs = {
  createProfileReferralInput: CreateProfileReferralInput;
};


export type RootMutationTypeCreateProviderArgs = {
  createProviderInput: CreateProviderInput;
};


export type RootMutationTypeCreateQuizResultArgs = {
  email: Scalars['String'];
  totalCorrect: Scalars['Int'];
  totalIncorrect: Scalars['Int'];
};


export type RootMutationTypeCreateReferralArgs = {
  description?: InputMaybe<Scalars['String']>;
  groupIds: Array<Scalars['ID']>;
  insuranceGroupNumber?: InputMaybe<Scalars['String']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  patientIsPreAuthorized?: InputMaybe<Scalars['Boolean']>;
  procedureId: Scalars['ID'];
  providerId: Scalars['ID'];
};


export type RootMutationTypeCreateScheduleForOrganizationArgs = {
  organizationId: Scalars['ID'];
  scheduleInput: ScheduleInput;
};


export type RootMutationTypeCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type RootMutationTypeCreateUserInOrganizationArgs = {
  email: Scalars['String'];
  hasAllLocations: Scalars['Boolean'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isEditor?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  userLocationIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationTypeDeleteAvailabilityArgs = {
  deleteAvailabilityInput: DeleteAvailabilityInput;
};


export type RootMutationTypeDeleteAvailabilityLimitArgs = {
  deleteAvailabilityLimitInput: DeleteAvailabilityLimitInput;
};


export type RootMutationTypeDeleteBlackoutDateArgs = {
  deleteBlackoutDateInput: DeleteBlackoutDateInput;
};


export type RootMutationTypeDeleteGroupOrganizationArgs = {
  deleteGroupOrganizationInput: DeleteGroupOrganizationInput;
};


export type RootMutationTypeDeleteGroupProfileArgs = {
  deleteGroupProfileInput: DeleteGroupProfileInput;
};


export type RootMutationTypeDeleteLinkArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteLinkTypeArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteProfilePayorArgs = {
  payorId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type RootMutationTypeDeleteProfilePlanArgs = {
  planId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type RootMutationTypeDeleteProfileProcedureArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteReferralDocumentArgs = {
  documentUrl: Scalars['String'];
  referralId: Scalars['ID'];
};


export type RootMutationTypeDeleteReferralOrderArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDisableProfileLimitArgs = {
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type RootMutationTypeEditUserArgs = {
  email: Scalars['String'];
  hasAllLocations: Scalars['Boolean'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActiveUserOrganization?: InputMaybe<Scalars['Boolean']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isEditor?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  profileLocationOnly?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type RootMutationTypeEnableProfileLimitArgs = {
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
  type: Scalars['String'];
};


export type RootMutationTypeFinishTaskArgs = {
  taskId: Scalars['ID'];
};


export type RootMutationTypeFreeSlotsArgs = {
  resourceId: Scalars['ID'];
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  token: Scalars['String'];
};


export type RootMutationTypeReserveSlotsArgs = {
  organizationId: Scalars['ID'];
  resourceId: Scalars['ID'];
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  token?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeSuperuserUpdateOrganizationArgs = {
  organizationId: Scalars['ID'];
  superuserUpdateOrganizationInput: SuperuserUpdateOrganizationInput;
};


export type RootMutationTypeUpdateAppointmentArgs = {
  updateAppointmentInput: UpdateAppointmentInput;
};


export type RootMutationTypeUpdateGroupArgs = {
  updateGroupInput: UpdateGroupInput;
};


export type RootMutationTypeUpdateGroupLocationsArgs = {
  updateGroupLocationsInput: UpdateGroupLocationsInput;
};


export type RootMutationTypeUpdateLinkArgs = {
  updateLinkInput: UpdateLinkInput;
};


export type RootMutationTypeUpdateLinkTypeArgs = {
  updateLinkTypeInput: UpdateLinkTypeInput;
};


export type RootMutationTypeUpdateLocationArgs = {
  updateLocationInput: UpdateLocationInput;
};


export type RootMutationTypeUpdateOrganizationArgs = {
  organizationId: Scalars['ID'];
  updateOrganizationInput: UpdateOrganizationInput;
};


export type RootMutationTypeUpdateOrganizationConsumerSchedulingSettingsArgs = {
  organizationId: Scalars['ID'];
  updateOrganizationConsumerSchedulingSettingsInput: UpdateOrganizationConsumerSchedulingSettingsInput;
};


export type RootMutationTypeUpdatePatientDemographicArgs = {
  organizationId: Scalars['ID'];
  patientId: Scalars['ID'];
  referralId?: InputMaybe<Scalars['ID']>;
  updatePatientDemographicInput: UpdatePatientDemographicInput;
};


export type RootMutationTypeUpdatePatientReferralArgs = {
  id: Scalars['ID'];
  updatePatientReferralInput: UpdatePatientReferralInput;
};


export type RootMutationTypeUpdateProfileReferralArgs = {
  id: Scalars['ID'];
  updateProfileReferralInput: UpdateProfileReferralInput;
};


export type RootMutationTypeUpdateProviderArgs = {
  updateProviderInput: UpdateProviderInput;
};


export type RootMutationTypeUpdateReferralArgs = {
  bookedByProvider?: InputMaybe<Scalars['Boolean']>;
  referralInput: ReferralInput;
};


export type RootMutationTypeUpdateReferralStatusArgs = {
  referralStatusInput: ReferralStatusInput;
};


export type RootMutationTypeUpdateScheduleArgs = {
  scheduleId: Scalars['ID'];
  scheduleInput: ScheduleInput;
};


export type RootMutationTypeUpdateUserOrganizationEmailNotificationsArgs = {
  emailNotifications: Scalars['Boolean'];
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeUpdateUserOrganizationSmsNotificationsArgs = {
  organizationId: Scalars['ID'];
  smsNotifications: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type RootMutationTypeUploadAppointmentAttachmentArgs = {
  appointmentId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type RootMutationTypeUploadReferralDocumentArgs = {
  file: Scalars['Upload'];
  referralId: Scalars['ID'];
  type: Scalars['String'];
};


export type RootMutationTypeUploadReferralOrderArgs = {
  file: Scalars['Upload'];
  referralId: Scalars['ID'];
  type: Scalars['String'];
};


export type RootMutationTypeUploadScheduleImageArgs = {
  uploadScheduleImageInput: UploadScheduleImageInput;
};


export type RootMutationTypeUpsertScheduleArgs = {
  upsertScheduleInput: UpsertScheduleInput;
};


export type RootMutationTypeUpsertSlotDurationArgs = {
  upsertSlotDurationInput: UpsertSlotDurationInput;
};


export type RootMutationTypeWatchQueueArgs = {
  workflowQueueId: Scalars['ID'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  codeSystemLookup?: Maybe<Array<Maybe<Value>>>;
  countLocationsInOrganization?: Maybe<Scalars['Int']>;
  countProfilesInOrganization?: Maybe<Scalars['Int']>;
  countProvidersInOrganization?: Maybe<Scalars['Int']>;
  countUsersInOrganization?: Maybe<Scalars['Int']>;
  createBillingPortalSession?: Maybe<BillingPortalSession>;
  getAllPayors?: Maybe<Array<Maybe<Payor>>>;
  getAllPayorsAndPlans?: Maybe<Array<Maybe<Payor>>>;
  getAllSchedules?: Maybe<PaginatedSchedules>;
  getAppointment?: Maybe<Appointment>;
  getAppointmentUrl?: Maybe<AppointmentUrl>;
  getAvailabilityLimitSummary?: Maybe<AvailabilityLimitSummary>;
  getCapabilityStatement?: Maybe<CapabilityStatement>;
  getConsumerSchedulingOrganization?: Maybe<PublicOrganization>;
  getConsumerSchedulingProfile?: Maybe<PublicProfile>;
  getConsumerSchedulingProfileSlots?: Maybe<Array<Maybe<Slot>>>;
  getDirectory?: Maybe<Directory>;
  getDirectoryProfiles?: Maybe<PaginatedPublicProfiles>;
  getFeatureFlags: Array<FeatureFlag>;
  getGroup?: Maybe<Group>;
  getLanguages: Array<Maybe<Language>>;
  getLocation?: Maybe<Location>;
  getOrganization?: Maybe<Organization>;
  getOrganizations?: Maybe<Array<Maybe<PublicOrganization>>>;
  getOwnSlots?: Maybe<Array<Maybe<Slot>>>;
  getPaginatedLocations?: Maybe<PaginatedLocations>;
  getPatient?: Maybe<Patient>;
  getPayorPlansByPayor?: Maybe<Array<Maybe<PayorPlan>>>;
  getPayorPlansByPayorAndProfiles?: Maybe<Array<Maybe<PayorPlan>>>;
  getPayorsAndPlansByOrganization?: Maybe<Array<Maybe<Payor>>>;
  getPayorsAndPlansByProfile?: Maybe<Array<Maybe<ProfilePlan>>>;
  getProcedure?: Maybe<Procedure>;
  getProfile?: Maybe<Profile>;
  getProfileLanguagesInOrganization?: Maybe<Array<Maybe<Language>>>;
  getProfiles?: Maybe<Array<Maybe<PublicProfile>>>;
  getProvider?: Maybe<Provider>;
  getPublicProfile?: Maybe<PublicProfile>;
  getPublicProfiles?: Maybe<Array<Maybe<PublicProfile>>>;
  getQuestionnaire?: Maybe<Questionnaire>;
  getReferral?: Maybe<Referral>;
  getReferralDocuments?: Maybe<Array<Maybe<ReferralDocument>>>;
  getReferralOrders?: Maybe<Array<Maybe<ReferralOrder>>>;
  getRegions?: Maybe<Array<Maybe<Region>>>;
  getSchedulingProfileSubscriptionForOrganization?: Maybe<PaymentsSubscription>;
  getSlotDuration?: Maybe<SlotDuration>;
  getSlots?: Maybe<Array<Maybe<Slot>>>;
  getSpecialtiesWithProfilesInOrganization?: Maybe<Array<Maybe<Specialty>>>;
  getSyncedAppointmentStatus?: Maybe<Appointment>;
  getTelehealthAttendee?: Maybe<TelehealthAttendee>;
  getUser?: Maybe<User>;
  getWaitListAvailabilities?: Maybe<WaitListAvailabilities>;
  getWorkflowQueue: WorkflowQueue;
  guessGeocode?: Maybe<Geocode>;
  isEligible?: Maybe<Eligibility>;
  links?: Maybe<Array<Maybe<Link>>>;
  linkTypes?: Maybe<Array<Maybe<LinkType>>>;
  listAppointments?: Maybe<PaginatedAppointments>;
  listAuditLogs?: Maybe<AuditLogsWithPagination>;
  listAvailabilities?: Maybe<Array<Maybe<Availability>>>;
  listBlackoutDates?: Maybe<Array<Maybe<BlackoutDate>>>;
  listExternalWorkflowQueues?: Maybe<Array<WorkflowQueue>>;
  listMessages?: Maybe<Array<Maybe<Message>>>;
  listProfiles?: Maybe<PaginatedProfiles>;
  listReferrals?: Maybe<ReferralsWithPagination>;
  listSpecialties?: Maybe<Array<Maybe<Specialty>>>;
  listSpecialtiesWithProfiles?: Maybe<Array<Maybe<Specialty>>>;
  listWorkflowQueues?: Maybe<Array<WorkflowQueue>>;
  lookupCodeSystemForAppointment?: Maybe<Array<Maybe<Value>>>;
  organization?: Maybe<Organization>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  paginatedProviders?: Maybe<PaginatedProviders>;
  paginatedUsers?: Maybe<PaginatedUsers>;
  searchConsumerSchedulingPatientsInOrganization?: Maybe<Array<Maybe<Patient>>>;
  searchDiagnoses?: Maybe<Array<Maybe<Diagnosis>>>;
  searchPatients?: Maybe<Array<Maybe<Patient>>>;
  searchProducts?: Maybe<Array<Maybe<Product>>>;
  searchProfilesInOrganization?: Maybe<Array<Maybe<PublicProfile>>>;
  searchReferralPatientsInOrganization?: Maybe<Array<Maybe<Patient>>>;
  searchSchedules?: Maybe<PaginatedSchedules>;
  searchTaxRates?: Maybe<Array<Maybe<TaxRate>>>;
  viewer?: Maybe<Viewer>;
  viewerOrganization?: Maybe<ViewerOrganization>;
};


export type RootQueryTypeCodeSystemLookupArgs = {
  profileId: Scalars['ID'];
  referralId: Scalars['ID'];
};


export type RootQueryTypeCountLocationsInOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeCountProfilesInOrganizationArgs = {
  organizationId: Scalars['ID'];
  searchProfilesInput: SearchProfilesInput;
};


export type RootQueryTypeCountProvidersInOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeCountUsersInOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeCreateBillingPortalSessionArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetAllSchedulesArgs = {
  distanceFromPatient?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageNumber?: Scalars['Int'];
  pageSize?: Scalars['Int'];
  referralId: Scalars['ID'];
  sort?: InputMaybe<SchedulingSortEnum>;
  textFilter?: InputMaybe<Scalars['String']>;
  totalEntries?: Scalars['Int'];
  totalPages?: Scalars['Int'];
};


export type RootQueryTypeGetAppointmentArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetAppointmentUrlArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetAvailabilityLimitSummaryArgs = {
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type RootQueryTypeGetCapabilityStatementArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetConsumerSchedulingOrganizationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetConsumerSchedulingProfileArgs = {
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};


export type RootQueryTypeGetConsumerSchedulingProfileSlotsArgs = {
  end?: InputMaybe<Scalars['String']>;
  procedureId: Scalars['ID'];
  profileId: Scalars['ID'];
  start?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetDirectoryArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetDirectoryProfilesArgs = {
  nameFilter?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['String']>;
  specialtyId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetGroupArgs = {
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeGetLocationArgs = {
  getLocationInput: GetLocationInput;
};


export type RootQueryTypeGetOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetOrganizationsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetOwnSlotsArgs = {
  originator?: InputMaybe<Scalars['String']>;
  patientIsPreAuthorized?: InputMaybe<Scalars['Boolean']>;
  procedureId: Scalars['ID'];
  profileId: Scalars['ID'];
  searchType?: InputMaybe<SearchType>;
  start?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetPaginatedLocationsArgs = {
  organizationId: Scalars['ID'];
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchFilter?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetPatientArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetPayorPlansByPayorArgs = {
  payorId: Scalars['ID'];
};


export type RootQueryTypeGetPayorPlansByPayorAndProfilesArgs = {
  payorId: Scalars['ID'];
  profileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type RootQueryTypeGetPayorsAndPlansByOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetPayorsAndPlansByProfileArgs = {
  profileId: Scalars['ID'];
};


export type RootQueryTypeGetProcedureArgs = {
  procedureId: Scalars['ID'];
};


export type RootQueryTypeGetProfileArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetProfileLanguagesInOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetProfilesArgs = {
  nameFilter?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetProviderArgs = {
  getProviderInput: GetProviderInput;
};


export type RootQueryTypeGetPublicProfileArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetPublicProfilesArgs = {
  type?: InputMaybe<ProfileType>;
};


export type RootQueryTypeGetQuestionnaireArgs = {
  questionnaireId: Scalars['ID'];
};


export type RootQueryTypeGetReferralArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetReferralDocumentsArgs = {
  referralId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetReferralOrdersArgs = {
  referralId: Scalars['ID'];
  type: Scalars['String'];
};


export type RootQueryTypeGetSchedulingProfileSubscriptionForOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeGetSlotDurationArgs = {
  scheduleId: Scalars['ID'];
};


export type RootQueryTypeGetSlotsArgs = {
  end?: InputMaybe<Scalars['String']>;
  originator?: InputMaybe<Scalars['String']>;
  payorPlanId?: InputMaybe<Scalars['String']>;
  profileId: Scalars['ID'];
  referralId: Scalars['ID'];
  start?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetSpecialtiesWithProfilesInOrganizationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetSyncedAppointmentStatusArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetTelehealthAttendeeArgs = {
  appointmentId: Scalars['ID'];
  attendeeName: Scalars['String'];
};


export type RootQueryTypeGetUserArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetWaitListAvailabilitiesArgs = {
  getWaitListAvailabilitiesInput: GetWaitListAvailabilitiesInput;
};


export type RootQueryTypeGetWorkflowQueueArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGuessGeocodeArgs = {
  searchTerm: Scalars['String'];
};


export type RootQueryTypeIsEligibleArgs = {
  patientId: Scalars['String'];
  profileId: Scalars['String'];
};


export type RootQueryTypeLinksArgs = {
  filter?: InputMaybe<LinkFilter>;
};


export type RootQueryTypeLinkTypesArgs = {
  filter?: InputMaybe<LinkTypeFilter>;
};


export type RootQueryTypeListAppointmentsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  organizationId: Scalars['ID'];
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sortField?: InputMaybe<AppointmentSortColumn>;
  sortOrder?: InputMaybe<AppointmentOrdering>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeListAuditLogsArgs = {
  action?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  recordId?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeListAvailabilitiesArgs = {
  listAvailabilitiesInput: ListAvailabilitiesInput;
};


export type RootQueryTypeListBlackoutDatesArgs = {
  listBlackoutDatesInput: ListBlackoutDatesInput;
};


export type RootQueryTypeListExternalWorkflowQueuesArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeListMessagesArgs = {
  referralId: Scalars['ID'];
};


export type RootQueryTypeListProfilesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeListReferralsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  organizationId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['ID']>;
  sortField?: InputMaybe<ReferralSortColumn>;
  sortOrder?: InputMaybe<ReferralOrdering>;
  startDate?: InputMaybe<Scalars['String']>;
  type?: ReferralViewType;
};


export type RootQueryTypeListSpecialtiesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeListSpecialtiesWithProfilesArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeListWorkflowQueuesArgs = {
  organizationId: Scalars['ID'];
};


export type RootQueryTypeLookupCodeSystemForAppointmentArgs = {
  appointmentId: Scalars['ID'];
};


export type RootQueryTypeOrganizationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePaginatedProvidersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypePaginatedUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeSearchConsumerSchedulingPatientsInOrganizationArgs = {
  organizationId: Scalars['ID'];
  searchText: Scalars['String'];
};


export type RootQueryTypeSearchDiagnosesArgs = {
  filter: Scalars['String'];
};


export type RootQueryTypeSearchPatientsArgs = {
  filter: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type RootQueryTypeSearchProductsArgs = {
  searchProductsInput: SearchProductsInput;
};


export type RootQueryTypeSearchProfilesInOrganizationArgs = {
  organizationId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchProfilesInput: SearchProfilesInput;
};


export type RootQueryTypeSearchReferralPatientsInOrganizationArgs = {
  organizationId: Scalars['ID'];
  searchText: Scalars['String'];
};


export type RootQueryTypeSearchSchedulesArgs = {
  distanceFromPatient?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  profileId?: InputMaybe<Scalars['ID']>;
  referralId: Scalars['ID'];
  sort?: InputMaybe<SchedulingSortEnum>;
  textFilter?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeSearchTaxRatesArgs = {
  searchTaxRatesInput: SearchTaxRatesInput;
};


export type RootQueryTypeViewerArgs = {
  currentOrganizationId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  skipLocations?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeViewerOrganizationArgs = {
  organizationId: Scalars['ID'];
};

export type Schedule = {
  __typename?: 'Schedule';
  id: Scalars['ID'];
  insuranceConfidence?: Maybe<Scalars['String']>;
  insuranceNetwork?: Maybe<Scalars['String']>;
  profile: Profile;
};

export type ScheduleInput = {
  boardCertifications?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  educationTraining?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  generalPatientInstructions?: InputMaybe<Scalars['String']>;
  groupKey?: InputMaybe<Scalars['String']>;
  hasAppointmentRequests?: InputMaybe<Scalars['Boolean']>;
  hasConsumerScheduling?: InputMaybe<Scalars['Boolean']>;
  hasConsumerSchedulingSlots?: InputMaybe<Scalars['Boolean']>;
  hasReferralScheduling?: InputMaybe<Scalars['Boolean']>;
  hasReferralSchedulingSlots?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']>;
  isSendToPatient?: InputMaybe<Scalars['Boolean']>;
  isSendToProvider?: InputMaybe<Scalars['Boolean']>;
  isWaitList?: InputMaybe<Scalars['Boolean']>;
  languageCodes: Array<InputMaybe<Scalars['String']>>;
  lastName?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  npiNumber?: InputMaybe<Scalars['String']>;
  onlyAllowsAgeMax?: InputMaybe<Scalars['Int']>;
  onlyAllowsAgeMin?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  professionalStatement?: InputMaybe<Scalars['String']>;
  profileImgUrl?: InputMaybe<Scalars['String']>;
  referralSearchNotice?: InputMaybe<Scalars['String']>;
  slotStartBufferInM?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export enum SchedulingSortEnum {
  Availability = 'AVAILABILITY',
  Distance = 'DISTANCE',
  NextAvailability = 'NEXT_AVAILABILITY'
}

export type SearchProductsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SearchProfilesInput = {
  displayName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Sex>;
  hasConsumerScheduling?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']>;
  languageCode?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationId?: InputMaybe<Scalars['ID']>;
  longitude?: InputMaybe<Scalars['Float']>;
  npiNumber?: InputMaybe<Scalars['String']>;
  organizationIsActive?: InputMaybe<Scalars['Boolean']>;
  payorId?: InputMaybe<Scalars['ID']>;
  payorPlanId?: InputMaybe<Scalars['ID']>;
  procedureId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<ConsumerSchedulingSort>;
  specialtyId?: InputMaybe<Scalars['ID']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type SearchTaxRatesInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SearchTaxRatesSort>;
};

export enum SearchTaxRatesSort {
  Jurisdiction = 'JURISDICTION'
}

export enum SearchType {
  All = 'ALL',
  Consumer = 'CONSUMER',
  Referral = 'REFERRAL'
}

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type Slot = {
  __typename?: 'Slot';
  end: Scalars['NaiveDateTime'];
  id: Scalars['ID'];
  profileId?: Maybe<Scalars['ID']>;
  serviceType?: Maybe<Array<Maybe<CodeableConcept>>>;
  slotIdsForAppointment?: Maybe<Array<Maybe<Scalars['ID']>>>;
  start: Scalars['NaiveDateTime'];
  status: Scalars['String'];
};

export type SlotDuration = {
  __typename?: 'SlotDuration';
  durationInMins: Scalars['Int'];
  scheduleId: Scalars['ID'];
};

export type Specialty = {
  __typename?: 'Specialty';
  id: Scalars['ID'];
  isDiagnosisRequired?: Maybe<Scalars['Boolean']>;
  isOrderRequired?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  procedures?: Maybe<Array<Maybe<Procedure>>>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  id: Scalars['ID'];
  price: Price;
  quantity: Scalars['Int'];
};

export type SuperuserUpdateOrganizationInput = {
  featureFlagIds?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['ID']>;
};

export enum TaskStatus {
  Expired = 'EXPIRED',
  Finished = 'FINISHED',
  Inprogress = 'INPROGRESS',
  Moved = 'MOVED',
  Ready = 'READY'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  inclusive: Scalars['Boolean'];
  jurisdiction?: Maybe<Scalars['String']>;
  percentage: Scalars['Float'];
};

export type TelehealthAttendee = {
  __typename?: 'TelehealthAttendee';
  chimeAttendee: ChimeAttendee;
  chimeMeeting: ChimeMeeting;
};

export enum TimeZone {
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaCuracao = 'AMERICA_CURACAO',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaDetroit = 'AMERICA_DETROIT',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AmericaPhoenix = 'AMERICA_PHOENIX'
}

export type UpdateAppointmentInput = {
  id: Scalars['ID'];
  status: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<AppointmentTagsInput>>>;
};

export type UpdateGroupInput = {
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isReferralNetwork?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupLocationsInput = {
  groupId: Scalars['ID'];
  locationIds: Array<InputMaybe<Scalars['String']>>;
};

export type UpdateLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  linkTypeId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  profileId?: InputMaybe<Scalars['ID']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateLinkTypeInput = {
  id: Scalars['ID'];
  linkType?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type UpdateLocationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  hasAppointmentRequests: Scalars['Boolean'];
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  timeZone: TimeZone;
};

export type UpdateOrganizationConsumerSchedulingSettingsInput = {
  allowAttachments?: InputMaybe<Scalars['Boolean']>;
  formFieldSettings?: InputMaybe<Array<InputMaybe<OrganizationFormFieldSettingsInput>>>;
  googleTagManagerId?: InputMaybe<Scalars['String']>;
  htmlFooter?: InputMaybe<Scalars['String']>;
  htmlHeader?: InputMaybe<Scalars['String']>;
  htmlHeadTags?: InputMaybe<Scalars['String']>;
  noAvailabilityAction?: InputMaybe<Scalars['String']>;
  noAvailabilityText?: InputMaybe<Scalars['String']>;
  searchInsurance?: InputMaybe<Scalars['Boolean']>;
  searchProviders?: InputMaybe<Scalars['Boolean']>;
  showLanguages?: InputMaybe<Scalars['Boolean']>;
  showMap?: InputMaybe<Scalars['Boolean']>;
  showPatientPrefill?: InputMaybe<Scalars['Boolean']>;
  visitTypeFormLabel?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationInput = {
  customEmailSubject?: InputMaybe<Scalars['String']>;
  customEmailText?: InputMaybe<Scalars['String']>;
  defaultDateFilterRange?: InputMaybe<Scalars['String']>;
  defaultReferralSearchRadius?: InputMaybe<Scalars['Int']>;
  defaultReferralSort?: InputMaybe<Scalars['String']>;
  enablePatientCancellation?: InputMaybe<Scalars['Boolean']>;
  enablePatientRescheduling?: InputMaybe<Scalars['Boolean']>;
  hideEmailFieldInReferral?: InputMaybe<Scalars['Boolean']>;
  maxInactiveUserDays?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  patientEmailFromAddress?: InputMaybe<Scalars['String']>;
  profileImgFile?: InputMaybe<Scalars['Upload']>;
  searchProfilesWithoutScheduling?: InputMaybe<Scalars['Boolean']>;
  sendPatientNotifications?: InputMaybe<Scalars['Boolean']>;
  showInsuranceFilters?: InputMaybe<Scalars['Boolean']>;
  showInsuranceFiltersDuringScheduling?: InputMaybe<Scalars['Boolean']>;
  showSendToPatient?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  useClickToSearchForPatients?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatePatientDemographicInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dob: Scalars['Date'];
  email?: InputMaybe<Scalars['String']>;
  familyName: Scalars['String'];
  givenName1: Scalars['String'];
  givenName2?: InputMaybe<Scalars['String']>;
  givenName3?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneType?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredLanguageCode?: InputMaybe<Scalars['String']>;
  sex: Sex;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdatePatientReferralInput = {
  patientEmail?: InputMaybe<Scalars['String']>;
};

export type UpdateProfileReferralInput = {
  patientEmail?: InputMaybe<Scalars['String']>;
};

export type UpdateProviderInput = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  key?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  npi: Scalars['String'];
};

export type UploadScheduleImageInput = {
  file: Scalars['Upload'];
};

export type UpsertScheduleInput = {
  boardCertifications?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  educationTraining?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  generalPatientInstructions?: InputMaybe<Scalars['String']>;
  groupKey?: InputMaybe<Scalars['String']>;
  hasAppointmentRequests?: InputMaybe<Scalars['Boolean']>;
  hasConsumerScheduling?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']>;
  isSendToPatient?: InputMaybe<Scalars['Boolean']>;
  isSendToProvider?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<InputMaybe<LanguageInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  npiNumber?: InputMaybe<Scalars['String']>;
  onlyAllowsAgeMax?: InputMaybe<Scalars['Int']>;
  onlyAllowsAgeMin?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  professionalStatement?: InputMaybe<Scalars['String']>;
  profileImgUrl?: InputMaybe<Scalars['String']>;
  referralSearchNotice?: InputMaybe<Scalars['String']>;
  slotStartBufferInM?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UpsertSlotDurationInput = {
  durationInMins: Scalars['Int'];
  scheduleId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  avatarUrl: Scalars['String'];
  blockitAdmin?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  hasAllLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isEditor?: Maybe<Scalars['Boolean']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  profileLocationOnly?: Maybe<Scalars['Boolean']>;
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
};


export type UserHasAllLocationsArgs = {
  organizationId: Scalars['ID'];
};


export type UserIsAdminArgs = {
  organizationId: Scalars['ID'];
};


export type UserIsEditorArgs = {
  organizationId: Scalars['ID'];
};


export type UserLocationsArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type UserUserOrganizationsArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  emailNotifications?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
  smsNotifications?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export enum UserRole {
  Admin = 'ADMIN',
  BlockitAdmin = 'BLOCKIT_ADMIN',
  Editor = 'EDITOR',
  Scheduler = 'SCHEDULER'
}

export type Value = {
  __typename?: 'Value';
  name: Scalars['String'];
  valueString: Scalars['String'];
};

export type Viewer = {
  __typename?: 'Viewer';
  blockitAdmin: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organizations?: Maybe<Array<Maybe<ViewerOrganization>>>;
  profileLocationOnly?: Maybe<Scalars['Boolean']>;
};

export type ViewerLocation = {
  __typename?: 'ViewerLocation';
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  receives: Scalars['Boolean'];
  sends: Scalars['Boolean'];
};

export type ViewerOrganization = {
  __typename?: 'ViewerOrganization';
  accessCenterProfileId?: Maybe<Scalars['ID']>;
  cancelReasons?: Maybe<Array<Maybe<Reason>>>;
  consumerSchedulingSettings?: Maybe<ConsumerSchedulingSettings>;
  defaultDateFilterRange?: Maybe<Scalars['String']>;
  defaultReferralSearchRadius?: Maybe<Scalars['Int']>;
  defaultReferralSort?: Maybe<Scalars['String']>;
  featureFlags: Array<FeatureFlag>;
  freePlanConfiguration?: Maybe<FreePlanConfiguration>;
  hasSso: Scalars['Boolean'];
  hasSsoStrict: Scalars['Boolean'];
  hideEmailFieldInReferral?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isCovid: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  locations?: Maybe<Array<Maybe<ViewerLocation>>>;
  name: Scalars['String'];
  referralCancelReasons?: Maybe<Array<Maybe<Reason>>>;
  referralRejectionReasons?: Maybe<Array<Maybe<Reason>>>;
  referralSettings?: Maybe<ReferralSettings>;
  region?: Maybe<Region>;
  role: UserRole;
  showInsuranceFilters?: Maybe<Scalars['Boolean']>;
  showSendToPatient?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  useClickToSearchForPatients?: Maybe<Scalars['Boolean']>;
};

export type WaitListAvailabilities = {
  __typename?: 'WaitListAvailabilities';
  availabilities: Array<Maybe<WaitListAvailability>>;
  profileId: Scalars['ID'];
  type: Scalars['String'];
};

export type WaitListAvailability = {
  __typename?: 'WaitListAvailability';
  end?: Maybe<Scalars['String']>;
  freeSlotsCount: Scalars['Int'];
  start?: Maybe<Scalars['String']>;
};

export type WorkflowQueue = {
  __typename?: 'WorkflowQueue';
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isInternal?: Maybe<Scalars['Boolean']>;
  manualTrigger: Scalars['Boolean'];
  name: Scalars['String'];
  questionnaires?: Maybe<Array<Maybe<Questionnaire>>>;
  showAcceptButton?: Maybe<Scalars['Boolean']>;
  showRelatedQueues?: Maybe<Scalars['Boolean']>;
  showScheduleButton?: Maybe<Scalars['Boolean']>;
  tasks: Array<WorkflowQueueTask>;
  template: Scalars['String'];
  triggerType: Scalars['String'];
  viewerWatching: Scalars['Boolean'];
};

export type WorkflowQueueTask = {
  __typename?: 'WorkflowQueueTask';
  appointment?: Maybe<Appointment>;
  finishedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['String']>;
  referral?: Maybe<Referral>;
  startedAt?: Maybe<Scalars['String']>;
  status: TaskStatus;
  user?: Maybe<User>;
  viewerIsOwner: Scalars['Boolean'];
  workflowQueue?: Maybe<WorkflowQueue>;
};

export type FreeSlotsMutationVariables = Exact<{
  slotIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  resourceId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type FreeSlotsMutation = { __typename?: 'RootMutationType', freeSlots?: { __typename?: 'Reservation', token: string } | null };

export type ReserveSlotsMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  slotIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  resourceId: Scalars['ID'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type ReserveSlotsMutation = { __typename?: 'RootMutationType', reserveSlots?: { __typename?: 'Reservation', token: string } | null };

export type AddTaskMutationVariables = Exact<{
  referralId: Scalars['ID'];
  workflowQueueId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['ID']>;
  questionnaireAnswerSets?: InputMaybe<Array<QuestionnaireAnswerSet> | QuestionnaireAnswerSet>;
}>;


export type AddTaskMutation = { __typename?: 'RootMutationType', addTask: { __typename?: 'WorkflowQueueTask', id: string, status: TaskStatus } };

export type GetPatientQueryVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type GetPatientQuery = { __typename?: 'RootQueryType', getPatient?: { __typename?: 'Patient', id: string, identifier?: string | null, givenName1: string, givenName2?: string | null, givenName3?: string | null, familyName: string, sex: string, dob: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, phone?: string | null, email?: string | null } | null };

export type AcceptTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type AcceptTaskMutation = { __typename?: 'RootMutationType', acceptTask: { __typename?: 'WorkflowQueueTask', id: string, status: TaskStatus, viewerIsOwner: boolean, user?: { __typename?: 'User', id: string, name: string } | null } };

export type FinishTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type FinishTaskMutation = { __typename?: 'RootMutationType', finishTask: { __typename?: 'WorkflowQueueTask', id: string, status: TaskStatus, viewerIsOwner: boolean, finishedAt?: string | null, user?: { __typename?: 'User', id: string, name: string } | null } };

export type GetWorkflowQueueQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkflowQueueQuery = { __typename?: 'RootQueryType', getWorkflowQueue: { __typename?: 'WorkflowQueue', id: string, name: string, isInternal?: boolean | null, color?: string | null, triggerType: string, viewerWatching: boolean, showRelatedQueues?: boolean | null, showScheduleButton?: boolean | null, showAcceptButton?: boolean | null, template: string, tasks: Array<{ __typename?: 'WorkflowQueueTask', id: string, status: TaskStatus, viewerIsOwner: boolean, startedAt?: string | null, finishedAt?: string | null, insertedAt?: string | null, user?: { __typename?: 'User', id: string, name: string } | null, referral?: { __typename?: 'Referral', id: string, status: string, insertedAt?: string | null, isSchedulable?: boolean | null, tags?: Array<{ __typename?: 'ReferralTags', key?: string | null, value?: string | null } | null> | null, procedure: { __typename?: 'Procedure', id: string, name?: string | null }, patientReferral?: { __typename?: 'PatientReferral', id: string, profile?: { __typename?: 'PublicProfile', id: string, displayName: string } | null } | null, profileReferral?: { __typename?: 'ProfileReferral', id: string, profile?: { __typename?: 'PublicProfile', id: string, displayName: string } | null } | null, provider: { __typename?: 'Provider', id: string, name: string, npi: string }, patient?: { __typename?: 'Patient', id: string, givenName1: string, familyName: string, phone?: string | null, email?: string | null, address1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null } | null, tasks?: Array<{ __typename?: 'WorkflowQueueTask', id: string, workflowQueue?: { __typename?: 'WorkflowQueue', id: string, name: string } | null } | null> | null } | null, appointment?: { __typename?: 'Appointment', id: string, status: string, procedure?: { __typename?: 'Procedure', id: string, name?: string | null } | null, profile: { __typename?: 'Profile', id: string, displayName: string }, patient?: { __typename?: 'Patient', id: string, givenName1: string, familyName: string, phone?: string | null, email?: string | null, address1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null } | null } | null }> } };

export type ListExternalWorkflowQueuesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ListExternalWorkflowQueuesQuery = { __typename?: 'RootQueryType', listExternalWorkflowQueues?: Array<{ __typename?: 'WorkflowQueue', id: string, name: string, isInternal?: boolean | null, color?: string | null, manualTrigger: boolean, triggerType: string, showRelatedQueues?: boolean | null, showScheduleButton?: boolean | null, showAcceptButton?: boolean | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, title?: string | null, name?: string | null, type?: string | null, items?: Array<{ __typename?: 'QuestionnaireItems', id: string, text?: string | null, type?: string | null, required?: boolean | null, initialValue?: string | null, options?: Array<string | null> | null, key?: string | null, uploadAcceptTypes?: Array<string | null> | null } | null> | null } | null> | null }> | null };

export type ListWorkflowQueuesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ListWorkflowQueuesQuery = { __typename?: 'RootQueryType', listWorkflowQueues?: Array<{ __typename?: 'WorkflowQueue', id: string, name: string, isInternal?: boolean | null, color?: string | null, manualTrigger: boolean, triggerType: string, showRelatedQueues?: boolean | null, showScheduleButton?: boolean | null, showAcceptButton?: boolean | null, questionnaires?: Array<{ __typename?: 'Questionnaire', id: string, title?: string | null, name?: string | null, type?: string | null, items?: Array<{ __typename?: 'QuestionnaireItems', id: string, text?: string | null, type?: string | null, required?: boolean | null, initialValue?: string | null, options?: Array<string | null> | null, key?: string | null, helpText?: string | null, uploadAcceptTypes?: Array<string | null> | null } | null> | null } | null> | null }> | null };

export type WatchQueueMutationVariables = Exact<{
  workflowQueueId: Scalars['ID'];
}>;


export type WatchQueueMutation = { __typename?: 'RootMutationType', watchQueue: { __typename?: 'WorkflowQueue', id: string, name: string, viewerWatching: boolean } };


export const FreeSlotsDocument = gql`
    mutation FreeSlots($slotIds: [ID]!, $resourceId: ID!, $token: String!) {
  freeSlots(slotIds: $slotIds, resourceId: $resourceId, token: $token) {
    token
  }
}
    `;
export type FreeSlotsMutationFn = Apollo.MutationFunction<FreeSlotsMutation, FreeSlotsMutationVariables>;

/**
 * __useFreeSlotsMutation__
 *
 * To run a mutation, you first call `useFreeSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreeSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freeSlotsMutation, { data, loading, error }] = useFreeSlotsMutation({
 *   variables: {
 *      slotIds: // value for 'slotIds'
 *      resourceId: // value for 'resourceId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFreeSlotsMutation(baseOptions?: Apollo.MutationHookOptions<FreeSlotsMutation, FreeSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreeSlotsMutation, FreeSlotsMutationVariables>(FreeSlotsDocument, options);
      }
export type FreeSlotsMutationHookResult = ReturnType<typeof useFreeSlotsMutation>;
export type FreeSlotsMutationResult = Apollo.MutationResult<FreeSlotsMutation>;
export type FreeSlotsMutationOptions = Apollo.BaseMutationOptions<FreeSlotsMutation, FreeSlotsMutationVariables>;
export const ReserveSlotsDocument = gql`
    mutation ReserveSlots($organizationId: ID!, $slotIds: [ID]!, $resourceId: ID!, $token: String) {
  reserveSlots(organizationId: $organizationId, slotIds: $slotIds, resourceId: $resourceId, token: $token) {
    token
  }
}
    `;
export type ReserveSlotsMutationFn = Apollo.MutationFunction<ReserveSlotsMutation, ReserveSlotsMutationVariables>;

/**
 * __useReserveSlotsMutation__
 *
 * To run a mutation, you first call `useReserveSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveSlotsMutation, { data, loading, error }] = useReserveSlotsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      slotIds: // value for 'slotIds'
 *      resourceId: // value for 'resourceId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReserveSlotsMutation(baseOptions?: Apollo.MutationHookOptions<ReserveSlotsMutation, ReserveSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReserveSlotsMutation, ReserveSlotsMutationVariables>(ReserveSlotsDocument, options);
      }
export type ReserveSlotsMutationHookResult = ReturnType<typeof useReserveSlotsMutation>;
export type ReserveSlotsMutationResult = Apollo.MutationResult<ReserveSlotsMutation>;
export type ReserveSlotsMutationOptions = Apollo.BaseMutationOptions<ReserveSlotsMutation, ReserveSlotsMutationVariables>;
export const AddTaskDocument = gql`
    mutation addTask($referralId: ID!, $workflowQueueId: ID!, $notes: String, $taskId: ID, $questionnaireAnswerSets: [QuestionnaireAnswerSet!]) {
  addTask(referralId: $referralId, workflowQueueId: $workflowQueueId, notes: $notes, taskId: $taskId, questionnaireAnswerSets: $questionnaireAnswerSets) {
    id
    status
  }
}
    `;
export type AddTaskMutationFn = Apollo.MutationFunction<AddTaskMutation, AddTaskMutationVariables>;

/**
 * __useAddTaskMutation__
 *
 * To run a mutation, you first call `useAddTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskMutation, { data, loading, error }] = useAddTaskMutation({
 *   variables: {
 *      referralId: // value for 'referralId'
 *      workflowQueueId: // value for 'workflowQueueId'
 *      notes: // value for 'notes'
 *      taskId: // value for 'taskId'
 *      questionnaireAnswerSets: // value for 'questionnaireAnswerSets'
 *   },
 * });
 */
export function useAddTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskMutation, AddTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskMutation, AddTaskMutationVariables>(AddTaskDocument, options);
      }
export type AddTaskMutationHookResult = ReturnType<typeof useAddTaskMutation>;
export type AddTaskMutationResult = Apollo.MutationResult<AddTaskMutation>;
export type AddTaskMutationOptions = Apollo.BaseMutationOptions<AddTaskMutation, AddTaskMutationVariables>;
export const GetPatientDocument = gql`
    query GetPatient($id: ID!, $organizationId: ID!) {
  getPatient(id: $id, organizationId: $organizationId) {
    id
    identifier
    givenName1
    givenName2
    givenName3
    familyName
    sex
    dob
    address1
    address2
    city
    state
    postalCode
    phone
    email
  }
}
    `;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const AcceptTaskDocument = gql`
    mutation acceptTask($taskId: ID!) {
  acceptTask(taskId: $taskId) {
    id
    status
    viewerIsOwner
    user {
      id
      name
    }
  }
}
    `;
export type AcceptTaskMutationFn = Apollo.MutationFunction<AcceptTaskMutation, AcceptTaskMutationVariables>;

/**
 * __useAcceptTaskMutation__
 *
 * To run a mutation, you first call `useAcceptTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTaskMutation, { data, loading, error }] = useAcceptTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAcceptTaskMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTaskMutation, AcceptTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTaskMutation, AcceptTaskMutationVariables>(AcceptTaskDocument, options);
      }
export type AcceptTaskMutationHookResult = ReturnType<typeof useAcceptTaskMutation>;
export type AcceptTaskMutationResult = Apollo.MutationResult<AcceptTaskMutation>;
export type AcceptTaskMutationOptions = Apollo.BaseMutationOptions<AcceptTaskMutation, AcceptTaskMutationVariables>;
export const FinishTaskDocument = gql`
    mutation finishTask($taskId: ID!) {
  finishTask(taskId: $taskId) {
    id
    status
    viewerIsOwner
    finishedAt
    user {
      id
      name
    }
  }
}
    `;
export type FinishTaskMutationFn = Apollo.MutationFunction<FinishTaskMutation, FinishTaskMutationVariables>;

/**
 * __useFinishTaskMutation__
 *
 * To run a mutation, you first call `useFinishTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishTaskMutation, { data, loading, error }] = useFinishTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useFinishTaskMutation(baseOptions?: Apollo.MutationHookOptions<FinishTaskMutation, FinishTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishTaskMutation, FinishTaskMutationVariables>(FinishTaskDocument, options);
      }
export type FinishTaskMutationHookResult = ReturnType<typeof useFinishTaskMutation>;
export type FinishTaskMutationResult = Apollo.MutationResult<FinishTaskMutation>;
export type FinishTaskMutationOptions = Apollo.BaseMutationOptions<FinishTaskMutation, FinishTaskMutationVariables>;
export const GetWorkflowQueueDocument = gql`
    query GetWorkflowQueue($id: ID!) {
  getWorkflowQueue(id: $id) {
    id
    name
    isInternal
    color
    triggerType
    viewerWatching
    showRelatedQueues
    showScheduleButton
    showAcceptButton
    template
    tasks {
      id
      status
      viewerIsOwner
      startedAt
      finishedAt
      insertedAt
      user {
        id
        name
      }
      referral {
        id
        status
        insertedAt
        isSchedulable
        tags {
          key
          value
        }
        procedure {
          id
          name
        }
        patientReferral {
          id
          profile {
            id
            displayName
          }
        }
        profileReferral {
          id
          profile {
            id
            displayName
          }
        }
        provider {
          id
          name
          npi
        }
        patient {
          id
          givenName1
          familyName
          phone
          email
          address1
          city
          state
          postalCode
        }
        tasks {
          id
          workflowQueue {
            id
            name
          }
        }
      }
      appointment {
        id
        status
        procedure {
          id
          name
        }
        profile {
          id
          displayName
        }
        patient {
          id
          givenName1
          familyName
          phone
          email
          address1
          city
          state
          postalCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowQueueQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQueueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowQueueQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowQueueQuery, GetWorkflowQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowQueueQuery, GetWorkflowQueueQueryVariables>(GetWorkflowQueueDocument, options);
      }
export function useGetWorkflowQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowQueueQuery, GetWorkflowQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowQueueQuery, GetWorkflowQueueQueryVariables>(GetWorkflowQueueDocument, options);
        }
export type GetWorkflowQueueQueryHookResult = ReturnType<typeof useGetWorkflowQueueQuery>;
export type GetWorkflowQueueLazyQueryHookResult = ReturnType<typeof useGetWorkflowQueueLazyQuery>;
export type GetWorkflowQueueQueryResult = Apollo.QueryResult<GetWorkflowQueueQuery, GetWorkflowQueueQueryVariables>;
export const ListExternalWorkflowQueuesDocument = gql`
    query ListExternalWorkflowQueues($organizationId: ID!) {
  listExternalWorkflowQueues(organizationId: $organizationId) {
    id
    name
    isInternal
    color
    manualTrigger
    triggerType
    showRelatedQueues
    showScheduleButton
    showAcceptButton
    questionnaires {
      id
      title
      name
      type
      items {
        id
        text
        type
        required
        initialValue
        options
        key
        uploadAcceptTypes
      }
    }
  }
}
    `;

/**
 * __useListExternalWorkflowQueuesQuery__
 *
 * To run a query within a React component, call `useListExternalWorkflowQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExternalWorkflowQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExternalWorkflowQueuesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListExternalWorkflowQueuesQuery(baseOptions: Apollo.QueryHookOptions<ListExternalWorkflowQueuesQuery, ListExternalWorkflowQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExternalWorkflowQueuesQuery, ListExternalWorkflowQueuesQueryVariables>(ListExternalWorkflowQueuesDocument, options);
      }
export function useListExternalWorkflowQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExternalWorkflowQueuesQuery, ListExternalWorkflowQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExternalWorkflowQueuesQuery, ListExternalWorkflowQueuesQueryVariables>(ListExternalWorkflowQueuesDocument, options);
        }
export type ListExternalWorkflowQueuesQueryHookResult = ReturnType<typeof useListExternalWorkflowQueuesQuery>;
export type ListExternalWorkflowQueuesLazyQueryHookResult = ReturnType<typeof useListExternalWorkflowQueuesLazyQuery>;
export type ListExternalWorkflowQueuesQueryResult = Apollo.QueryResult<ListExternalWorkflowQueuesQuery, ListExternalWorkflowQueuesQueryVariables>;
export const ListWorkflowQueuesDocument = gql`
    query ListWorkflowQueues($organizationId: ID!) {
  listWorkflowQueues(organizationId: $organizationId) {
    id
    name
    isInternal
    color
    manualTrigger
    triggerType
    showRelatedQueues
    showScheduleButton
    showAcceptButton
    questionnaires {
      id
      title
      name
      type
      items {
        id
        text
        type
        required
        initialValue
        options
        key
        helpText
        uploadAcceptTypes
      }
    }
  }
}
    `;

/**
 * __useListWorkflowQueuesQuery__
 *
 * To run a query within a React component, call `useListWorkflowQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowQueuesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListWorkflowQueuesQuery(baseOptions: Apollo.QueryHookOptions<ListWorkflowQueuesQuery, ListWorkflowQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkflowQueuesQuery, ListWorkflowQueuesQueryVariables>(ListWorkflowQueuesDocument, options);
      }
export function useListWorkflowQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkflowQueuesQuery, ListWorkflowQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkflowQueuesQuery, ListWorkflowQueuesQueryVariables>(ListWorkflowQueuesDocument, options);
        }
export type ListWorkflowQueuesQueryHookResult = ReturnType<typeof useListWorkflowQueuesQuery>;
export type ListWorkflowQueuesLazyQueryHookResult = ReturnType<typeof useListWorkflowQueuesLazyQuery>;
export type ListWorkflowQueuesQueryResult = Apollo.QueryResult<ListWorkflowQueuesQuery, ListWorkflowQueuesQueryVariables>;
export const WatchQueueDocument = gql`
    mutation watchQueue($workflowQueueId: ID!) {
  watchQueue(workflowQueueId: $workflowQueueId) {
    id
    name
    viewerWatching
  }
}
    `;
export type WatchQueueMutationFn = Apollo.MutationFunction<WatchQueueMutation, WatchQueueMutationVariables>;

/**
 * __useWatchQueueMutation__
 *
 * To run a mutation, you first call `useWatchQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchQueueMutation, { data, loading, error }] = useWatchQueueMutation({
 *   variables: {
 *      workflowQueueId: // value for 'workflowQueueId'
 *   },
 * });
 */
export function useWatchQueueMutation(baseOptions?: Apollo.MutationHookOptions<WatchQueueMutation, WatchQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchQueueMutation, WatchQueueMutationVariables>(WatchQueueDocument, options);
      }
export type WatchQueueMutationHookResult = ReturnType<typeof useWatchQueueMutation>;
export type WatchQueueMutationResult = Apollo.MutationResult<WatchQueueMutation>;
export type WatchQueueMutationOptions = Apollo.BaseMutationOptions<WatchQueueMutation, WatchQueueMutationVariables>;